// frontend/src/pages/BookingDetailPage.tsx
// FIXED: Auto-detects context from route and user role

import React from 'react';
import { useLocation } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import BookingDetailNew from '@/components/Booking/BookingDetailNew';

// Helper function to detect context from route
const detectContext = (pathname: string, userRole?: string): 'admin' | 'provider' | 'customer' => {
  // Customer routes start with /account/
  if (pathname.startsWith('/account/')) return 'customer';
  
  // For /bookings routes, determine by user role
  if (userRole === 'admin' || userRole === 'super_admin') return 'admin';
  if (userRole === 'provider') return 'provider';
  
  // Default fallback
  return 'customer';
};

const BookingDetailPage: React.FC = () => {
  const { user } = useAuth();
  const location = useLocation();
  
  // Auto-detect context from route and user role
  const context = detectContext(location.pathname, user?.role);

  return (
    <BookingDetailNew 
      context={context}
    />
  );
};

export default BookingDetailPage;